import {popup} from '@acng/frontend-discovery';
import {ClickEventController} from 'nova';

import {post} from '../../core/service/backend.js';
import {coreFeature} from '../../core/config/feature.js';
import {t} from '../../locale/config/translate.js';

/**
 * Deactivate Account Button
 *
 * @example
 *
 * ```html
 * <!--@ ${auth.deactivate} -->
 * <button>Deactivate</button>
 * ```
 */
const clickDeactivate = new ClickEventController(async (element) => {
  const question = await t('userPool.confirmDeactivation');

  await coreFeature.popup(
    element,
    'confirm',
    (close) => ({
      question,
      yes: async () => {
        const url = 'user/deactivate';
        await post(url, {}, element);
        await popup(element).info(await t('userPool.deactivated'));
        location.reload();
      },
      no: () => close(),
    }),
    true,
  );
});

export {clickDeactivate};
